{
  "pt": {
    "notification": {
      "actions": {
        "delete": "Eliminar a notificação",
        "deleteAll": "Eliminar tudo",
        "markAllAsRead": "Marcar tudo como lido",
        "mark_as_read": "Marcar como lido",
        "mark_as_unread": "Marcar como não lido"
      },
      "customers": {
        "announcement": {
          "create": "criou uma publicação de notícias. | criou {group_notification_count} publicações de notícias. |_| criou {group_notification_count} publicações de notícias."
        },
        "decision": {
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "published": {
            "customer": "decisão adicionada <i>'{notifiable_name}'</i>."
          },
          "relaunched": "tornou a decisão <i>'{notifiable_name}'</i> novamente disponível."
        },
        "decision_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | carregou {group_notification_count} documentos na decisão <i>'{group_name}'</i>. |_| carregou {group_notification_count} documentos na decisão <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "proposta aprovada <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | aprovou {group_notification_count} propostas na decisão <i>'{group_name}'</i>. | aprovou {group_notification_count} propostas na decisão <i>'{group_name}'</i>.",
          "create": "proposta criada <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | criou {group_notification_count} propostas na decisão <i>'{group_name}'</i>. | criou {group_notification_count} propostas na decisão <i>'{group_name}'</i>.",
          "edit_approved": "editou a proposta aprovada <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | editou {group_notification_count} propostas aprovadas na decisão <i>'{group_name}'</i>. | editou {group_notification_count} propostas aprovadas na decisão <i>'{group_name}'</i>.",
          "relaunched": "tornou novamente disponível a proposta <i>'{notifiable_name}'</i> para a qual foram solicitadas alterações | tornou novamente disponíveis {group_notification_count} propostas na decisão <i>'{group_name}'</i> para as quais foram solicitadas alterações | tornou novamente disponíveis {group_notification_count} propostas na decisão <i>'{group_name}'</i> para as quais foram solicitadas alterações"
        },
        "document": {
          "create": "documento carregado <i>'{notifiable_name}'</i>. | carregou {group_notification_count} documentos. |_| carregou {group_notification_count} documentos.",
          "installment": {
            "create": "adicionada uma fatura <i>'{notifiable_name}'</i> a uma prestação. | adicionou {group_notification_count} faturas a uma prestação. |_| adicionou {group_notification_count} faturas a uma prestação."
          },
          "invoice": {
            "create": "fatura carregada <i>'{notifiable_name}'</i>. | carregou {group_notification_count} faturas. |_| carregou {group_notification_count} faturas."
          },
          "proposal": {
            "create": "adicionado o documento <i>'{notifiable_name}'</i> à proposta <i>'{group_name}'</i>. | adicionou {group_notification_count} documentos à proposta <i>'{group_name}'</i>. |_| adicionou {group_notification_count} documentos à proposta <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Os seus dados de exportação estão prontos para serem descarregados."
        },
        "installment": {
          "published": "disponibilizou a prestação <i>'{notifiable_name}'</i>. | tornou {group_notification_count} prestações disponíveis. | tornou {group_notification_count} prestações disponíveis.",
          "status": {
            "changed": "alterou o estado da prestação <i>'{notifiable_name}'</i> para <i>'{status}'</i>. | alterou o estado de {group_notification_count} prestações. | alterou o estado de {group_notification_count} prestações."
          }
        },
        "issue": {
          "approval": {
            "create": "solicitou aprovação para o defeito <i>'{notifiable_name}'</i> | solicitou aprovação para {group_notification_count} defeitos. | solicitou aprovação para {group_notification_count} defeitos."
          },
          "create": "criou o defeito <i>'{notifiable_name}'</i> | criou {group_notification_count} defeitos | criou {group_notification_count} defeitos",
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "status": {
            "update": "atualizou o estado de <i>'{notifiable_name}'</i> para <i>'{status}'</i> | atualizou o estado de {group_notification_count} defeitos. | atualizou o estado de {group_notification_count} defeitos."
          }
        },
        "question": {
          "create": "criou a pergunta <i>'{notifiable_name}'</i> em FAQ <i>'{group_name}'</i>. | criou {group_notification_count} perguntas em FAQ <i>'{group_name}'</i>. |_| criou {group_notification_count} perguntas em FAQ <i>'{group_name}'</i>."
        },
        "reminder": {
          "decision": {
            "due": "Não se esqueça de tomar uma decisão para <i>'{notifiable_name}'</i>."
          },
          "installment": {
            "due": "Não se esqueça de efetuar um pagamento para <i>'{notifiable_name}'</i>."
          }
        },
        "survey": {
          "published": "gostaria de receber a sua opinião sobre <i>'{group_name}'</i>."
        },
        "task_assignment": {
          "confirmation": {
            "requested": "pede-lhe para confirmar <i>'{notifiable_name}'</i>."
          },
          "upload": {
            "requested": "pede-lhe para carregar um documento para <i>'{notifiable_name}'</i>."
          }
        },
        "ticket": {
          "create": "iniciou a conversa <i>'{notifiable_name}'</i>.",
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>.",
            "move": "moveu a sua mensagem para a conversa <i>'{group_name}'</i>"
          }
        },
        "ticket_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> em conversa <i>'{group_name}'</i>. | carregou {group_notification_count} documentos em conversa <i>'{group_name}'</i>. |_| carregou {group_notification_count} documentos em conversa <i>'{group_name}'</i>."
        }
      },
      "employees": {
        "announcement": {
          "create": "criou uma publicação de notícias. | criou {group_notification_count} publicações de notícias em <i>'{group_name}'</i>. |_| criou {group_notification_count} publicações de notícias em <i>'{group_name}'</i>."
        },
        "decision": {
          "mention": {
            "create": "mencionou-o numa conversa <i>'{group_name}'</i>. | mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>. |_| mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>."
          },
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "not_interested": "não está interessado na decisão <i>'{notifiable_name}'</i>.",
          "responsible": {
            "update": "tornou-o o novo responsável pela decisão <i>'{notifiable_name}'</i>"
          }
        },
        "decision_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | carregou {group_notification_count} documentos na decisão <i>'{group_name}'</i>. |_| carregou {group_notification_count} documentos na decisão <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "proposta aprovada <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | aprovou {group_notification_count} propostas na decisão <i>'{group_name}'</i>. |_| aprovou {group_notification_count} propostas na decisão <i>'{group_name}'</i>.",
          "create": "proposta criada <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | criou {group_notification_count} propostas na decisão <i>'{group_name}'</i>. |_| criou {group_notification_count} propostas na decisão <i>'{group_name}'</i>.",
          "requested_changes": "solicita alterações para a proposta <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | solicita alterações para {group_notification_count} propostas na decisão <i>'{group_name}'</i>. |_| solicita alterações para {group_notification_count} propostas na decisão <i>'{group_name}'</i>."
        },
        "document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> no diretório <i>'{group_name}'</i>. | carregou {group_notification_count} documentos no diretório <i>'{group_name}'</i>. |_| carregou {group_notification_count} documentos no diretório <i>'{group_name}'</i>.",
          "employee_create": "documento carregado <i>'{notifiable_name}'</i> no diretório <i>'{group_name}'</i>. | carregou {group_notification_count} documentos no diretório <i>'{group_name}'</i>. |_| carregou {group_notification_count} documentos no diretório <i>'{group_name}'</i>.",
          "proposal": {
            "create": "adicionado o documento <i>'{notifiable_name}'</i> à proposta <i>'{group_name}'</i>. | adicionou {group_notification_count} documentos à proposta <i>'{group_name}'</i>. |_| adicionou {group_notification_count} documentos à proposta <i>'{group_name}'</i>."
          }
        },
        "email_conversation": {
          "client": {
            "create": "recebeu um e-mail de entrada <i>'{notifiable_name}'</i>. | recebeu {group_notification_count} e-mails de entrada. |_| recebeu {group_notification_count} e-mails de entrada."
          },
          "project": {
            "create": "recebeu um e-mail de entrada <i>'{notifiable_name}'</i>. | recebeu {group_notification_count} e-mails de entrada. |_| recebeu {group_notification_count} e-mails de entrada."
          }
        },
        "export": {
          "create": "Os seus dados de exportação estão prontos para serem descarregados."
        },
        "issue": {
          "approved": "aprovou o defeito <i>'{notifiable_name}'</i> para a unidade <i>'{level_name}'</i>. | aprovou {group_notification_count} defeitos'</i>. |_| aprovou {group_notification_count} defeitos.",
          "create": "criou um novo defeito para a unidade <i>{level_name}</i> | criou {group_notification_count} novos defeitos para <i>{level_name}</i> |_| criou {group_notification_count} novos defeitos para <i>{level_name}</i>",
          "mention": {
            "create": "mencionou-o numa conversa <i>'{group_name}'</i>. | mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>. |_| mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>."
          },
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "rejected": "rejeitou o defeito <i>'{notifiable_name}'</i> para a unidade <i>'{level_name}'</i>. | rejeitou {group_notification_count} defeitos'</i>. |_| rejeitou {group_notification_count} defeitos."
        },
        "issue_list": {
          "responsible": {
            "update": "designou-o como o novo responsável pela lista de defeitos <i>'{notifiable_name}'</i>."
          }
        },
        "question": {
          "create": "criou a pergunta <i>'{notifiable_name}'</i> em FAQ <i>'{group_name}'</i>. | criou {group_notification_count} perguntas em FAQ <i>'{group_name}'</i>. |_| criou {group_notification_count} perguntas em FAQ <i>'{group_name}'</i>."
        },
        "survey_answer": {
          "create": "respondeu <i>'{group_name}'</i>."
        },
        "task_assignment": {
          "completed": "concluiu <i>'{notifiable_name}'</i>.",
          "confirmation": {
            "requested": "pede-lhe para confirmar <i>'{notifiable_name}'</i>."
          },
          "upload": {
            "requested": "pede-lhe para carregar um documento para <i>'{notifiable_name}'</i>."
          }
        },
        "ticket": {
          "create": "iniciou a conversa <i>'{notifiable_name}'</i>.",
          "mention": {
            "create": "mencionou-o numa conversa <i>'{group_name}'</i>. | mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>. |_| mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>."
          },
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "responsible": {
            "bulk_update": "transferiu a responsabilidade das conversas no projeto <i>'{project_name}'</i> de <i>{responsible_old_name}</i> para si.",
            "update": "conversa atribuída <i>'{notifiable_name}'</i> a si."
          }
        },
        "ticket_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> em conversa <i>'{group_name}'</i>. | carregou {group_notification_count} documentos em conversa <i>'{group_name}'</i>. |_| carregou {group_notification_count} documentos em conversa <i>'{group_name}'</i>."
        },
        "todo": {
          "assign": "atribuiu-lhe a tarefa <i>'{notifiable_name}'</i> na lista <i>'{group_name}'</i>. | atribuiu {group_notification_count} tarefas a si na lista <i>'{group_name}'</i>. | atribuiu a tarefa <i>'{notifiable_name}'</i> a si na lista <i>'{group_name}'</i>. | atribuiu {group_notification_count} tarefas a si na lista <i>'{group_name}'</i>."
        }
      },
      "labels": {
        "all": "Todos os projetos",
        "allDecisions": "Todas as decisões",
        "allStatuses": "Todos",
        "compactView": "Vista compacta",
        "expandedView": "Vista expandida",
        "filter": "Filtro",
        "hideDecisionFilter": "Ocultar filtro de decisão",
        "hideExtraFilters": "Ocultar filtros extra",
        "noNewNotification": "Já está tudo em dia!",
        "noResults": "Sem resultados. Tenta outra coisa!",
        "none": "Atualmente, não tem quaisquer notificações.",
        "notification_level_name_asc": "Unidade A-Z",
        "notification_level_name_desc": "Unidade Z-A",
        "pinSidebar": "Pino da barra lateral",
        "showDecisionFilter": "Mostrar filtro de decisão",
        "showExtraFilters": "Mostrar filtros extra",
        "sort": "Ordenar por",
        "status": "Estado",
        "unpinSidebar": "Desafixar a barra lateral",
        "unreadOnly": "Apenas não lidos",
        "updated_at_asc": "O mais antigo primeiro",
        "updated_at_desc": "Mais recente primeiro"
      },
      "other_user": "e 1 outro",
      "other_users": "e 1 outro | e {count} outros",
      "partners": {
        "decision": {
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "not_interested": "não está interessado na decisão <i>'{notifiable_name}'</i>.",
          "published": {
            "partners": "decisão iniciada <i>'{notifiable_name}'</i>. | iniciou {group_notification_count} decisões <i>'{group_name}'</i>. |_| iniciou {group_notification_count} decisões <i>'{group_name}'</i>."
          }
        },
        "decision_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | carregou {group_notification_count} documentos na decisão <i>'{group_name}'</i>. |_| carregou {group_notification_count} documentos na decisão <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "aprovou a proposta <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | aprovou a proposta <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | aprovou uma proposta na decisão <i>'{group_name}'</i>. | aprovou propostas na decisão <i>'{group_name}'</i>.",
          "create": "proposta criada <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | criou {group_notification_count} propostas na decisão <i>'{group_name}'</i>. |_| criou {group_notification_count} propostas na decisão <i>'{group_name}'</i>.",
          "requested_changes": "solicita alterações para a proposta <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | solicita alterações para {group_notification_count} propostas na decisão <i>'{group_name}'</i>. |_| solicita alterações para {group_notification_count} propostas na decisão <i>'{group_name}'</i>."
        },
        "document": {
          "create": "partilhou o documento <i>'{notifiable_name}'</i> consigo. | partilhou {group_notification_count} documentos consigo. |_| partilhou {group_notification_count} documentos consigo.",
          "proposal": {
            "create": "adicionado o documento <i>'{notifiable_name}'</i> à proposta <i>'{group_name}'</i>. | adicionou {group_notification_count} documentos à proposta <i>'{group_name}'</i>. |_| adicionou {group_notification_count} documentos à proposta <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Os seus dados de exportação estão prontos para serem descarregados."
        },
        "issue": {
          "status": {
            "update": "atualizou o estado de um defeito em <i>'{group_name}'</i>. | atualizou o estado de {group_notification_count} defeitos em <i>'{group_name}'</i>. |_| atualizou o estado de {group_notification_count} defeitos em <i>'{group_name}'</i>."
          }
        },
        "issue_list": {
          "published": "publicou uma lista de defeitos <i>'{notifiable_name}'</i> | publicou a lista de defeitos <i>'{notifiable_name}'</i> para {group_notification_count} unidades |_| publicou a lista de defeitos <i>'{notifiable_name}'</i> para {group_notification_count} unidades"
        },
        "reminder": {
          "due": "<i>'{notifiable_name}'</i> não foi decidido para a unidade {level_name}."
        },
        "ticket_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> em conversa <i>'{group_name}'</i>. | carregou {group_notification_count} documentos em conversa <i>'{group_name}'</i>. |_| carregou {group_notification_count} documentos em conversa <i>'{group_name}'</i>."
        },
        "unit": {
          "visibled": "adicionou o cliente <i>'{customer_group_name}'</i> a <i>'{group_name}'</i> para a unidade <i>'{notifiable_name}'</i>."
        }
      },
      "title": "Notificações"
    }
  }
}
